<template>
  <div class="content-wrapper">
    <el-row :gutter="20">
      <el-col :span="4">
        <help-menu />
      </el-col>
      <el-col :span="20">
        <div class="help-content">
          <h2 class="help-title">关于我们</h2>
          <p class="help-paragraph">多利网是负责百威营销辅助用品（非酒类）的销售网站，网站主要销售百威旗下所有品牌相关的提示物、DA及桌椅伞等。如：开瓶器、冰桶、大提篮、烟灰缸、海报、跳跳卡、台卡、推拉贴、WIFI贴、围裙、塑料桌椅、遮阳伞及冰柜等。</p>
          <p class="help-paragraph">【办公地址】 上海市浦东新区碧波路690号张江微电子港1号楼403-2</p>
          <p class="help-paragraph">【联系电话】 4008-050-979</p>
          <p class="help-paragraph">【市场联系人】 Tina Zhang</p>
        </div>
        <div class="help-content">
          <h2 class="help-title">服务热线</h2>
          <p class="help-paragraph">4008-050-979（服务时间：周一至周五9:00-18:00）</p>
          <h2 class="help-title">服务邮箱</h2>
          <p class="help-paragraph">abi.service@jcipn.com（服务时间：周一至周五9:00-18:00）</p>
        </div>
        <!-- <div class="help-content">
          <h2 class="help-title">百威英博</h2>
          <p class="help-paragraph">百威英博（Anheuser-Busch InBev）是一家上市公司，总部位于比利时鲁汶。百威英博是全球领先的酿酒制造商，也是全球五大消费品公司之一。作为一家以消费者为中心、以销售为推动力的大型公司，百威英博旗下经营着超过200多个品牌，其中包括百威、时代(Stella Artois)、贝克啤酒等全球旗舰品牌； Leffe、Hoegaarden等迅速成长的跨国畅销品牌；以及Bud Light、Skol、Brahma、Quilmes、Michelob、哈尔滨啤酒、雪津、Klinskoye、Sibirskaya、Sibirskaya Korona、Chernigivske、Jupiler等本土明星品牌。此外，公司拥有Grupo Modelo公司50%的股份。Grupo Modelo是墨西哥领先的啤酒制造商，也是享誉全球的科罗娜啤酒品牌所有者。</p>
          <p class="help-paragraph">百威英博中国在全国拥有超过35个酒厂，遍布12个省：</p>
          <p class="help-paragraph">黑龙江、吉林、 辽宁、福建、江西、广东、江苏、 浙江、湖南、湖北、河南、四川</p>
          <p class="help-paragraph">品牌：</p>
          <p class="help-paragraph">百威、哈尔滨、雪津、红石梁、双鹿、KK、 金陵、金龙泉、唐山</p>
          <p class="help-paragraph">中国雇员总数近三万六千名</p>
          <p class="help-paragraph">在中国, 我们的使命是做全世界最佳啤酒公司，酿造更美好的世界。</p>
        </div> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import HelpMenu from './components/help-menu'
export default {
  name: 'HelpAbout',
  components: {
    HelpMenu
  }
}
</script>

<style>

</style>
